"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = __importDefault(require("../utils/styled-components"));
var Wrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  box-sizing: border-box;\n  display: block;\n\n  margin: ", ";\n\n  padding: ", ";\n"], ["\n  box-sizing: border-box;\n  display: block;\n\n  margin: ",
    ";\n\n  padding: ",
    ";\n"])), function (_a) {
    var component = _a.theme.component, customMargin = _a.customMargin;
    return customMargin || component.dynamicYield.default.wrapper.margin;
}, function (_a) {
    var component = _a.theme.component, customPadding = _a.customPadding;
    return customPadding || component.dynamicYield.default.wrapper.padding;
});
exports.default = Wrapper;
var templateObject_1;
//# sourceMappingURL=index.styles.js.map